"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _material = require("@mui/material");
var _constants = require("../constants");
var _timePickerMenu = _interopRequireDefault(require("../timePickerMenu"));
var _buttonV = _interopRequireDefault(require("../../buttonV2"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimePickerWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TimePickerWrapper, _Component);
  var _super = _createSuper(TimePickerWrapper);
  function TimePickerWrapper(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TimePickerWrapper);
    _this = _super.call(this, props);
    _this.inputRef = /*#__PURE__*/_react.default.createRef();
    _this.inputRef.current = props.renderInput;
    _this.handleTyping = _this.handleTyping.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TimePickerWrapper, [{
    key: "handleTyping",
    value: function handleTyping(e) {
      this.props.onChange(e.target.value);
    }
  }, {
    key: "renderToggleControl",
    value: function renderToggleControl() {
      var time = null;
      var newTime = (0, _momentTimezone.default)(this.props.value, this.props.format, true);
      if (newTime.isValid()) {
        time = newTime.format(this.props.format);
      } else {
        time = this.props.value;
      }
      var inputProps = {
        bsRole: 'toggle',
        customValue: time,
        inputIconClass: 'far fa-clock',
        onFocus: this.openDropDown,
        onBlur: this.handleTyping,
        onClick: function onClick() {
          return null;
        },
        name: this.props.name,
        key: 'togglecontrol'
      };
      var ToggleControl = this.inputRef.current;
      return /*#__PURE__*/_react.default.createElement(ToggleControl, inputProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        className = _this$props.className,
        onChange = _this$props.onChange;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        buttonType: "dropdown",
        muiButtonProps: {
          variant: 'outlined',
          color: 'secondary',
          disabled: this.props.disabled,
          endIcon: null,
          title: this.renderToggleControl(),
          disableFocusRipple: true,
          className: 'time-picker-btn-holder',
          sx: {
            p: 0,
            border: 'none',
            '&:hover': {
              border: 'none'
            }
          }
        },
        menuItems: [/*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          disableRipple: true,
          disableGutters: true,
          focusVisibleClassName: "time-picker-dropdown-focused",
          sx: {
            '&:hover': {
              background: 'none'
            },
            cursor: 'default'
          },
          className: "time-picker-dropdown-items date-picker-wrapper"
        }, /*#__PURE__*/_react.default.createElement(_timePickerMenu.default, {
          data: (0, _momentTimezone.default)(value, this.props.format, true),
          onChangeTime: onChange
        }))]
      }));
    }
  }]);
  return TimePickerWrapper;
}(_react.Component);
TimePickerWrapper.propTypes = {
  value: _propTypes.default.instanceOf(_momentTimezone.default).isRequired,
  onChange: _propTypes.default.func.isRequired,
  format: _propTypes.default.string,
  renderInput: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
TimePickerWrapper.defaultProps = {
  format: _constants.DATE_TIME_FORMAT.shortTimeAMPM,
  className: '',
  name: 'timePicker',
  disabled: false
};
var _default = TimePickerWrapper;
exports.default = _default;